import {
  // CanvasTexture,
  MeshBasicMaterial,
  LinearFilter,
  sRGBEncoding,
  // ClampToEdgeWrapping
  // TextureLoader,
  // Texture,
  // Texture
  // RGBAFormat,
  DataTexture,
  // UnsignedByteType
} from "three";

const cache = [];

import { createHiDPICanvas } from './functions';

const hiDP = false;

class Text {
  
  constructor( copy, size, type = 1 ) { // for 2:1 brick 

    let material, texture, ctx;

    const fontSize = ( window.CONFIG && window.CONFIG.font ) ? window.CONFIG.font.size :  36;
    const fontFamily = ( window.CONFIG && window.CONFIG.font ) ? window.CONFIG.font.family :  "rollerscript-smooth";

    if( !cache[type]  ){

      const useBitmap = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.bitmap :  false;
      const bitmap = ( window.ASSETS && useBitmap ) ? window.ASSETS.images.find(obj => { return obj.name === 'bricktop'+type }).data : null;

      let canvas;

      if( hiDP ){
        canvas = createHiDPICanvas( (size*2)*10, size*10  );
        ctx = canvas.getContext('2d', { colorSpace: "srgb" });
      }else{
        canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d', { colorSpace: "srgb" });
        canvas.width = (size*2) * 10;
        canvas.height = (size) * 10;
      }

      ctx.fillStyle = "gold";
      ctx.fillRect(0, 0, (size*2), size);

      if(bitmap && hiDP) ctx.drawImage(bitmap, 0,0, canvas.width/canvas.ratio, canvas.height/canvas.ratio );
      if(bitmap) ctx.drawImage(bitmap, 0,0, canvas.width, canvas.height );

      ctx.font = ( document.fonts.check( fontSize + "px " + fontFamily )  ) ? fontSize + "px " + fontFamily : fontSize + "px sans-serif";
      ctx.fillStyle = "rgba(0, 0, 0, 0.75)";
      ctx.textAlign = "center";
      ctx.textBaseline = 'top';

      ctx.save(); 

      material = new MeshBasicMaterial(); //new Texture( bitmap ); //new MeshBasicMaterial()
      material.needsUpdate = false;
      texture = new DataTexture( ctx.getImageData( 0, 0, ctx.canvas.width, ctx.canvas.height).data, ctx.canvas.width, ctx.canvas.height );

      /* CACHE IT */
      cache[type] = {};
      cache[type].material = material;
      cache[type].texture = texture;
      cache[type].bitmap = ctx.getImageData( 0, 0, canvas.width, canvas.height ); 
      cache[type].ctx = ctx;

      /* KILL THE CANVAS */
      // canvas.width = 1;
      // canvas.height = 1
      // ctx.clearRect(0,0,1,1);

    }else{

      material = cache[type].material.clone();
      texture = cache[type].texture.clone();
      ctx = cache[type].ctx;
      ctx.putImageData(cache[type].bitmap, 0, 0);
      ctx.restore();

    }
    
    /* ADD TEXT */
    
    // copy = 'Gary\nGoard 🧔🏻‍♂️';
    const lines = copy.split('\n');
    let x,y,w,h;
    w = (hiDP) ? ctx.canvas.width/ctx.canvas.ratio : ctx.canvas.width;
    h = (hiDP) ? ctx.canvas.height/ctx.canvas.ratio : ctx.canvas.height;
    for (let i = 0; i < lines.length; i++) {
      x = w/2;
      y = (h/2) - fontSize + ( fontSize * i);
      y += fontSize/2 // to account for message baked onto brick texture
      x = Math.round(x);
      y = Math.round(y);
      //ctx.strokeText( lines[i], x, y); // imrpoves the wegiht of font for mobile
      ctx.fillText( lines[i], x, y);
    }

    texture.image = ctx.getImageData( 0, 0, ctx.canvas.width, ctx.canvas.height);
    texture.flipY = true;
    material.map = texture;
    material.map.encoding = sRGBEncoding
    material.map.minFilter = LinearFilter;
    material.map.generateMipmaps = false;
    
    return material;

  }
}

export { Text };